exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".OSZQM{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center}._2BObq{width:221px;height:34px}._1wYNl{position:relative;margin-left:16px;width:87px;height:34px;background:none;border-radius:2px;border:1px solid #939393;font-size:12px;transition:border-color .3s ease;word-break:break-word}._1wYNl:hover{border-color:#a0a0a0}._1wYNl ._3XgjP{opacity:1;transition:opacity .3s ease}._1wYNl ._32uYr{opacity:0;transition:opacity .3s ease}._1wYNl.Cjq5h ._32uYr{opacity:1}._1wYNl.Cjq5h ._3XgjP{opacity:0}._32uYr{position:absolute;left:50%;top:50%;margin-left:-4px;margin-top:-7px;display:inline-block;text-align:center}._32uYr:after{content:\"\";display:block;width:7px;height:12px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg)}", ""]);

// exports
exports.locals = {
	"copy": "OSZQM",
	"iframe-code": "_2BObq",
	"iframeCode": "_2BObq",
	"copy-button": "_1wYNl",
	"copyButton": "_1wYNl",
	"text": "_3XgjP",
	"checkmark": "_32uYr",
	"success": "Cjq5h"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/widget/containers/share-overlay/embed-form/copy-content/styles.styl
// module id = 1436
// module chunks = mobile/mobile mobile-overlay/mobile-overlay full-screen-modals/full-screen-modals widget/strip widget/classic widget/compact